import React from "react";
import Toast from '@/Toast';
import FpCaptcha from "./FpCaptcha";
import { fetchRequest, getPlatform } from '$CONFIG/Fatch.config';
import { ApiPort } from '$ACTIONS/API';

class _Captcha extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            apiURL: "",
            challengeUuid: "",
            keyUri: "",  // 拖动的image元素
            chartUri: "", // 后端返回的待拼凑图表
            shuffleMatrix: [],   // 拼凑顺序
            loading: false
        }
    }
    componentDidMount() {
        this.props.captchaVisible === true && this.getCaptchaChallengeId();
    }

    // 获取Uuid,这个Uuid是验证中用到的唯一Key
    getCaptchaChallengeId = () => {
        const platform = getPlatform();
        const data = {
            "captchaType": "SLIDE",
            "applicationLanguage": "zh",
            "siteId": platform === 'Desktop' ? 16 : 17
        }
        this.setState({ loading: true })
        fetchRequest(ApiPort.ChallengeId, 'POST', data)
        .then((res) => {
                if (res.isSuccess) {
                    this.setState({
                        apiURL: res.result.apiURL,
                        challengeUuid: res.result.challengeUuid
                    })
                    this.getFpCaptcha(res.result.apiURL,res.result.challengeUuid)
                }
            }).catch((error) => {
                this.setState({ loading: false })
                console.log(error)
            })
    }
    /**
     * 获取初始的验证图形
     * @param {string} url 
     * @param {string} id
     */
    getFpCaptcha = (url, id) => {
        const data = {
            applicationLanguage: "zh",
            device: {},
        }
        fetchRequest(url + "/api/v1.0/challenge/" + id, 'POST', data)
            .then((res) => {
                if (res) {
                    if (['10001', '10002', '11001'].includes(String(res.code))) {
                        this.setState({
                            challengeUuid: res.challengeUuid,
                            keyUri: res.keyUri,
                            chartUri: res.chartUri,
                            shuffleMatrix: res.shuffleMatrix,
                        })
                    } else {
                        // 63301:超过可换图次数  63302:Challenge過期或不存在（验证逾时）
                        this.getCaptchaChallengeId()
                    }
                }
            }).catch((error) => {
                this.setState({ loading: false })
                console.log(error)
            })
    }
    // 判断坐标正确
    judgement = ({ x, y, cost }, callback) => {
        const { apiURL, challengeUuid } = this.state;
        const data = {
            challengeUuid: challengeUuid,
            activity: {
                answers: { "x": x, "y": y },
                cost: cost
            },
            applicationLanguage: "zh",
            device: {}
        }
        this.setState({ loading: true })
        fetchRequest(apiURL + "/api/v1.0/judgement", 'POST', data)
            .then((res) => {
                if (res) {
                    typeof callback === "function" && callback(res.code);
                    this.setState({ loading: false });
                }
            }).catch((error) => {
                console.log("坐标:", error.message);
                this.setState({ loading: false });
                typeof callback === "function" && callback(error.code)
            });
    }
    onReload = () => { // 刷新加载img
        const { apiURL, challengeUuid } = this.state;
        let data = {
            applicationLanguage: "zh",
            device: {}
        }
        this.setState({ loading: true })
        fetchRequest(apiURL + "/api/v1.0/chart/" + challengeUuid, 'POST', data)
            .then(res => {
                if (['10001', '10002', '11001'].includes(String(res.code))) {
                    this.setState({
                        chartUri: res.chartUri,
                        keyUri: res.keyUri,
                        shuffleMatrix: res.shuffleMatrix,
                    })
                } else {
                    // 63301:超过可换图次数  63302:Challenge過期或不存在（验证逾时）
                    this.getCaptchaChallengeId()
                }
            }).catch((error) => {
                Toast.fail("网络错误，请重试！", 2)
                this.setState({ loading: false })
                this.getCaptchaChallengeId()
                console.log("/api/v1.0/chart/", error)
            });
    }
    render() {
        const {
            keyUri,
            chartUri,
            shuffleMatrix,
            challengeUuid,
            loading
        } = this.state;
        const { captchaVisible, setCaptchaVisible, onLogin } = this.props;
        return <FpCaptcha
            visible={captchaVisible}
            setVisible={setCaptchaVisible}
            keyUri={keyUri}
            chartUri={chartUri}
            shuffleMatrix={shuffleMatrix}
            challengeUuid={challengeUuid}
            judgement={this.judgement}
            onLogin={onLogin}
            onReload={this.onReload}
            loading={loading}
            setLoading={(v) => { this.setState({ loading: v }) }}
        />
    }
}

export default _Captcha;